import { CoreView } from '@/components/Theme/Core/CoreView';
import { withStyles } from '@/components/Theme/Core/withStyles';

export const Column = withStyles(CoreView, {noSwitch: true, style: {flexDirection: 'column'}});